<template>
  <div class="form__input"
       :class="{'form__input--error': data.error}">
    <div class="form__input__wrap">
      <label :for="labelFor"
             v-word="labelWord" />
      <input v-model="inputValue"
             v-bind:id="cssId"
             type="text"
             v-word="{ word: labelWord, attr: enablePlaceholder ? 'placeholder' : '_' }">
    </div>
    <p v-if="data.error"
       class="form__input__error">{{ data.error }}</p>
    <div class="form__input__hint"
         v-word="hintWord" />
  </div>
</template>

<script>
import wordings from '../utils/wordings';
import wordDirective from '../directives/word';
import formElement from '../mixins/form-element';

export default {
  props: [
    'label',
    'labelWord',
    'wordingsEditable',
    'wordings',
    'hint',
    'hintWord',
    'data',
    'wordingsMeta',
    'enablePlaceholder',
  ],
  mixins: [formElement],
  directives: {
    word: wordDirective,
  },
  data() {
    return {
      cssId: '',
    };
  },
  computed: {
    labelFor() {
      return this.wordingsEditable ? '' : this.cssId;
    },
    inputValue: {
      get() {
        return this.data.val;
      },
      set(newValue) {
        this.$emit('change', newValue, this.data.valName);
      },
    },
  },
  created() {
    if (this.id) {
      this.cssId = this.id;
    } else {
      this.cssId = '' + this.data.valName + '__' + Math.random();
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/InputText.vue